import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowInbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowInbox"><Path d="M20.5 14.5V20.5H3.5V14.5M12 3.5V15M8.5 12L12 15.5L15.5 12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowInbox;
